import PropTypes from 'prop-types';
import React from 'react';

export default function ErrorShortcut({title, link}) {
    if (!title || !link) {
        return null;
    }
    
    return (
        <li><a aria-label={title} className="ob-outline-button ob-error-block-shortcut" href={link}>
            {title}</a>
        </li>
    );
}

ErrorShortcut.propTypes = {
    title: PropTypes.string,
    link: PropTypes.string,
};